import React, { useContext, useState } from 'react'
import { firestore } from '../../../firebase';
import StateContext from '../../../StateContext'

function AddEquity() {

    const appState = useContext(StateContext)

    const [sum, setSum] = useState(0);
    const [konto, setKonto] = useState("");
    const [type, setType] = useState("");

    const [error, setError] = useState("");

    async function addEK(e) {
        e.preventDefault();
        try {
            const ekRef = firestore.collection("users").doc(appState.userId).collection("egenkapital");

            if (!type || !konto || !sum) {
                setError("Fyll ut alle feltene");
                return
            }

            const data = {
                konto,
                type,
                sum
            }
            ekRef.add(data);
        } catch (error) {
            setError("Noe gikk galt, ", error.message)
        }
    }

    return (
        <form onSubmit={addEK}>
            <label>Type</label>
            <input className="form-control mb-2" placeholder="Kontotype" value={konto} onChange={e => setKonto(e.target.value)} />
            <label>Konto</label>
            <input className="form-control mb-2" placeholder="Konto" value={type} onChange={e => setType(e.target.value)} />
            <label>Sum EK</label>
            <input type="number" className="form-control mb-2" placeholder="Sum EK" value={sum} onChange={e => setSum(e.target.value)} />
            {error && <div className="alert alert-danger">{error}</div>}
            <button className="btn btn-primary btn-block">Legg til EK</button>
        </form>
    )

}
export default AddEquity